import { http } from "@/libs/esg-acsp-core-vue-lib/utils/Http";

/**
 * 合同列表-查询接口
 */
export const queryMyContract = (data) =>
  http.post("/route/digital-store/api/auth/contract/search", data);

/**
 * 下载合同
 */
export const downloadContract = (contractNo, paramObj = {}) =>
  http.download({
    url: `/route/digital-store/api/auth/contract/download/${contractNo}`,
    method: "get",
    params: {
      ...paramObj,
    },
  });

/**
 * 合同详情
 */
export const contractDetail = (contractNo) =>
  http.get(`/route/digital-store/api/auth/contract/detail/${contractNo}`);

/**
 * 签署合同
 */
export const contractSign = (contractNo) =>
  http.get(`/route/digital-store/api/auth/contract/sign/${contractNo}`);

/**
 * 待签署提醒
 */
export const contractTips = () =>
  http.get("/route/digital-store/api/auth/contract/tips");
